import React from 'react';
import {
  TagsChipList,
  ChipListProps,
} from '@elementary/common-ui/components/ChipList';
import { useQuery } from '@tanstack/react-query';
import { METADATA_VALUES } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import * as api from 'shared/services/api';

const TagsChipListAutocomplete = React.forwardRef(
  (props: Omit<ChipListProps, 'buttonText'>, ref) => {
    const selectedEnvId = useSelectedEnv();

    const { data: metadataData } = useQuery(
      [METADATA_VALUES, selectedEnvId],
      () => api.fetchExtendedMetadataValueOptions(selectedEnvId!),
    );

    return (
      <TagsChipList
        ref={ref}
        buttonText="Add tag"
        autoCompleteOptions={metadataData?.tags}
        {...props}
      />
    );
  },
);

export default TagsChipListAutocomplete;
